// extracted by mini-css-extract-plugin
export default {"notificationBar":"JATTVz3uF9v8TRFdzjVA","alert":"YmpHvjcm2EtdH5VA2Yxx"};